import {ClickEvent} from "../../../../infrastructure/models/analytics/click-event";

export class NewSearchWidgetSportTypeClickEvent extends ClickEvent {
  id: Number;
  source: String;

  constructor(params: NewSearchWidgetSportTypeClickEvent) {
    super('', 'sport-type-click', 'search-tool');

    this.id = params.id;
    this.source = params.source;
  }

  get properties() {
    const properties = super.properties;

    properties.sportTypeId = this.id;
    properties.source = this.source;

    return properties;
  }
}